module.exports = __webpack_public_path__ + "images/v4b_header_mobile.bb5b0047.jpg";